export default __webpack_public_path__ + "static/media/roboto-v20-cyrillic_latin-regular.f3cc56e1.woff2";